import 'bootstrap/dist/js/bootstrap.bundle'

export const GForms = (function () {
	'use strict';

	let fieldsTooltips;

	function init() {
		$(document).on('gform_post_render', function(event, formId){
			$('[data-toggle="tooltip"]').tooltip({ trigger: 'click focus' });
		});
		$(document).bind('gform_post_render', function () {
			gformTooltips();

		});
	}
	
	function gformTooltips() {
		// Get all Gravity Forms Fields with tooltips.
		fieldsTooltips = document.querySelectorAll('.gfield-tooltip');
		
		if (!fieldsTooltips) { 
			return;
		}

		fieldsTooltips.forEach(function (field) {
			// Grab the description Field copy

			var gfieldDescription = field.querySelectorAll('.gfield_description');
			var gfieldLabel = field.querySelector('.gfield_label');

			if (gfieldDescription.length) {

				//Remove Node
				//field.removeChild(gfieldDescription[0]);
				gfieldDescription[0].remove();

				// Create the Tooltip markup
				var copyTooltip = '<div class="facet-tooltip" data-toggle="tooltip" data-placement="top"><p>'+gfieldDescription[0].innerHTML+'</p><img src="https://jenkinselectric.com/wp-content/uploads/2019/02/info-circle.svg" alt="Tooltip Icon"></div>';
				// var copyTooltip = '<div class="facet-tooltip" data-toggle="tooltip" data-placement="top" data-html="true" title="' + gfieldDescription[0].innerHTML + '"><p>'+gfieldDescription[0].innerHTML+'</p><img src="https://jenkinselectric.dev-staging.tech/wp-content/uploads/2019/02/info-circle.svg" alt="Tooltip Icon"></div>';

				// Move the markup into the label
				field.innerHTML = copyTooltip + field.innerHTML;
			}
		});

	};

	return {
		init: init,
	};
})();
